import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 최초 1회만 보여주는 툴팁/팝업/바텀 시트 등을 관리
interface inAppGuideState {
  layoutTooltip: boolean; //예약하기 그리드 툴팁
  sampleBudgetListTooltip: boolean; //결혼 예산 리스트 툴팁
  compareHallTooltip: boolean; //위시리스트 > 웨딩홀 비교하기 툴팁
  cashbackNudgeSnackbar: boolean; // 둘러보기 탭 > 캐시백 넛지스낵바
  addLikeMessage: boolean; // 예약하기 탭 > 찜 유도 팝업
  recommendHallMessage: number; // 예약하기 탭 > > 맞춤 추천 유도 팝업 (3회 제한)
  reservationHallMessage: number; // 예약하기 탭 > > 방문 예약 유도 팝업  (3회 제한)
  firstHomeMessage: boolean; // 최초 홈 화면 진입
  firstHomeHallTooltip: boolean; // 최초 홈 화면 홀 전체보기 툴팁
  weddingHallOnboarding: boolean; // 최초 웨딩홀 온보딩 페이지
}

const initialState: inAppGuideState = {
  layoutTooltip: true,
  sampleBudgetListTooltip: true,
  compareHallTooltip: true,
  cashbackNudgeSnackbar: true,
  addLikeMessage: true,
  recommendHallMessage: 0,
  reservationHallMessage: 0,
  firstHomeMessage: true,
  firstHomeHallTooltip: true,
  weddingHallOnboarding: true,
} as inAppGuideState;

const inAppGuideSlice = createSlice({
  name: "inAppGuide",
  initialState,
  reducers: {
    setLayoutTooltip(state, action: PayloadAction<boolean>) {
      state.layoutTooltip = action.payload;
    },
    setSampleBudgetListTooltip(state, action: PayloadAction<boolean>) {
      console.log(action.payload, "action.payload");
      state.sampleBudgetListTooltip = action.payload;
    },
    setCompareHallTooltip(state, action: PayloadAction<boolean>) {
      state.compareHallTooltip = action.payload;
    },
    setCashbackNudgeSnackbar(state, action: PayloadAction<boolean>) {
      state.cashbackNudgeSnackbar = action.payload;
    },
    setAddLikeMessage(state, action: PayloadAction<boolean>) {
      state.addLikeMessage = action.payload;
    },
    setRecommendHallMessage(state, action: PayloadAction<number>) {
      console.log("setRecommendHallMessage", action.payload);
      state.recommendHallMessage = action.payload;
    },
    setReservationHallMessage(state, action: PayloadAction<number>) {
      state.reservationHallMessage = action.payload;
    },
    setFirstHomeMessage(state, action: PayloadAction<boolean>) {
      state.firstHomeMessage = action.payload;
    },
    setFirstHomeHallTooltip(state, action: PayloadAction<boolean>) {
      state.firstHomeHallTooltip = action.payload;
    },
    setWeddingHallOnboarding(state, action: PayloadAction<boolean>) {
      state.weddingHallOnboarding = action.payload;
    },
  },
});

export const {
  setLayoutTooltip,
  setSampleBudgetListTooltip,
  setCompareHallTooltip,
  setCashbackNudgeSnackbar,
  setAddLikeMessage,
  setRecommendHallMessage,
  setReservationHallMessage,
  setFirstHomeMessage,
  setFirstHomeHallTooltip,
  setWeddingHallOnboarding,
} = inAppGuideSlice.actions;
export default inAppGuideSlice.reducer;
